import { render, staticRenderFns } from "./BundlePackageDetailsDialog.vue?vue&type=template&id=30fb5396&scoped=true"
import script from "./BundlePackageDetailsDialog.vue?vue&type=script&lang=js"
export * from "./BundlePackageDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./BundlePackageDetailsDialog.vue?vue&type=style&index=0&id=30fb5396&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fb5396",
  null
  
)

export default component.exports